// extracted by mini-css-extract-plugin
export var readonly = "_fd-1";
export var star = "_fd-0";